import { RichText as RichTextBase } from '@shared/messaging/src/RichTextHelper'

import { extensions } from './RichText.utils'

export default function RichText({ content, sx = {}, ...rest }) {
  return <RichTextBase extensions={extensions} content={content} sx={sx} {...rest} />
}
